"use strict";
import { ExternalLink } from "theme/components/Links";
import { Flex, Text, styled } from "ui/src";
const BannerWrapper = styled(Flex, {
  position: "relative",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "$surface2",
  p: 12,
  borderBottomWidth: 1,
  borderColor: "$surface3",
  width: "100%",
  zIndex: "$fixed",
  "$platform-web": {
    boxSizing: "border-box"
  }
});
export function DeprecationBanner() {
  return <BannerWrapper>
      <Text variant="body2" color="$neutral1" textAlign="center">
        Deli Swap is being deprecated as{" "}
        <ExternalLink href="https://www.useboardwalk.com" style={{ fontWeight: 600 }}>
          Boardwalk
        </ExternalLink>{" "}
        launches soon. Please close your positions and withdraw your funds.
      </Text>
    </BannerWrapper>;
}
